import { render } from "./MessageSquareIcon.vue?vue&type=template&id=637e445c"
import script from "./MessageSquareIcon.vue?vue&type=script&lang=js"
export * from "./MessageSquareIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__